/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00Ljk5OTk4IDE0LjcxTDQuMjg5OTggMTRMMTAuMjkgOC4wMDAwMUw0LjI4OTk4IDIuMDAwMDFMNC45OTk5OCAxLjI5MDAxTDExLjcxIDguMDAwMDFMNC45OTk5OCAxNC43MVoiIGZpbGw9ImluaGVyaXQiLz4=";